export default __webpack_public_path__ + "static/media/caio-circle.8a68d008.png";